<template>
  <div class="mobile-application">
    <section class="section-n-bg">
      <div class="container">
        <div class="row">
          <div class="col-12 section-n-bg-content">
            <div class="text-center n-header-text text-white">
              <h1 class="heading2 uppercase text-white text-uppercase">
                Aplikacja Librus nauczyciel
              </h1>
              <h1 class="heading2--regular uppercase text-white text-uppercase">
                Wsparcie Twojej codziennej pracy
              </h1>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 pb-5 text-center">
            <a
              href="https://play.google.com/store/apps/details?id=pl.librus.teacher"
              rel="noopener noreferrer"
              target="_blank"
              class="btn btn-outline-light btn-min-width text-uppercase mx-3 mt-3 mt-lg-0"
            >
              Pobierz z Google Play
            </a>
            <a
              href="https://apps.apple.com/pl/app/librus-nauczyciel/id1591474710"
              rel="noopener noreferrer"
              target="_blank"
              class="btn btn-outline-light btn-min-width text-uppercase mx-3 mt-3 mt-lg-0"
            >
              Pobierz z App Store
            </a>
          </div>
        </div>
      </div>
    </section>
    <section class="section-white">
      <div class="container py-0">
        <div class="row">
          <div class="col-12 text-center">
            <p class="heading3 text-uppercase">
              Informacje ze wszystkich Twoich szkół w jednym miejscu
            </p>
          </div>
          <div class="col-12 mt-5 mt-lg-0 overflow-hide text-center">
            <img
              src="../assets/images/foto/nauczyciel-telefon.png"
              class="internal-image"
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-3 col-md-6 col-sm-12 text-center">
            <img
              src="../assets/images/icons/n-multikonto.svg"
              class="icon-image-2x mt-md-3"
            />
            <h4 class="subtitle3 mt-5">Multikonto <br />pracownika</h4>
            <p class="mt-4 mw-82 mx-auto body3">
              Aplikacja umożliwia wygodne przeglądanie na jednym koncie danych
              nawet z kilku placówek
            </p>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 text-center">
            <img
              src="../assets/images/icons/n-sprawna.svg"
              class="icon-image-2x mt-md-3"
            />
            <h4 class="subtitle3 mt-5">Sprawna <br />organizacja dnia</h4>
            <p class="mt-4 mw-82 mx-auto body3">
              Plan lekcji, terminarz, zastępstwa, odwołania, lekcje z dzienników
              zajęć innych w jednym, przejrzystym widoku
            </p>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 text-center">
            <img
              src="../assets/images/icons/n-komunikacja.svg"
              class="icon-image-2x mt-md-5"
            />
            <h4 class="subtitle3 n-fast-comm-icon">Szybka <br />komunikacja</h4>
            <p class="mt-4 mw-82 mx-auto body3">
              Wiadomości i ogłoszenia pozwalają sprawnie komunikować się z
              uczniami, rodzicami i pracownikami szkoły
            </p>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 text-center">
            <img
              src="../assets/images/icons/n-wygodna.svg"
              class="icon-image-2x mt-icons"
            />
            <h4 class="subtitle3 mt-icons--text">
              Wygodny dostęp do informacji
            </h4>
            <p class="mt-4 mw-82 mx-auto body3">
              Powiadomienia, dzięki którym nie umkną najistotniejsze sprawy
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section-grey">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center mt-3 mb-5">
            <h2 class="heading3 text-uppercase">Najważniejsze funkcje</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center">
            <img
              class="internal-image sticky"
              src="../assets/images/foto/nauczyciel-funkcje.png"
            />
          </div>
          <div class="col-sm-12 col-md-7">
            <h4 class="subtitle4 text-orange mb-0">Multikonto</h4>
            <p class="body3">
              Przeglądaj dane z kilku placówek, w których pracujesz, bez
              potrzeby każdorazowego logowania. Mniej haseł do zapamiętywania i
              wpisywania - więcej czasu na to, co dla Ciebie najważniejsze.
            </p>
            <h4 class="subtitle4 mt-5 text-blue">Plan lekcji i Terminarz</h4>
            <p class="text-gray-2 body3">
              Sprawdź, jakie zadania czekają Cię danego dnia - harmonogram
              zajęć, terminarz, zastępstwa, przesunięcia, lekcje z dzienników
              zajęć innych - nawet z kilku szkół w jednym widoku.
            </p>
            <h4 class="subtitle4 mt-5 text-blue">Wiadomości</h4>
            <p class="text-gray-2 body3 mb-0">
              Odbieraj korespondencję, kiedy tylko chcesz i odpisuj na
              urządzeniu mobilnym.
            </p>
            <h4 class="subtitle4 mt-5 text-blue">Oś czasu</h4>
            <p class="text-gray-2 body3 mb-0">
              Zbiera i porządkuje w jednym miejscu najnowsze informacje ze
              wszystkich placówek, w których pracujesz.
            </p>
            <h4 class="subtitle4 mt-5 text-blue">Ogłoszenia</h4>
            <p class="text-gray-2 body3 mb-0">
              Najważniejsze komunikaty dotyczące funkcjonowania placówki pod
              ręką.
            </p>
            <h4 class="subtitle4 mt-5 text-blue">
              Natychmiastowe powiadomienia
            </h4>
            <p class="text-gray-2 body3 mb-0">
              Otrzymuj powiadomienia o nowych informacjach na Twoim koncie.
              Decyduj, które są dla Ciebie ważne i które chcesz dostawać.
              Będziesz wiedzieć, co dzieje się w pracy nawet bez otwierania
              aplikacji.
            </p>
            <h4 class="subtitle4 mt-5 text-blue">
              Uwierzytelnianie dwuskładnikowe (logowanie dwuetapowe)
            </h4>
            <p class="text-gray-2 body3 mb-0">
              Wykorzystaj aplikację do potwierdzenia tożsamości podczas
              logowania do systemu Synergia i podnieś bezpieczeństwo swojego
              konta.
            </p>
            <h4 class="subtitle4 mt-5 text-blue">LIBRUS spokojna noc</h4>
            <p class="text-gray-2 body3 mb-0">
              Włącz funkcję LIBRUS Spokojna noc i wycisz powiadomienia w godz.
              22:00-7:00. Śpij spokojnie, wiadomość np. o zmianie w planie
              lekcji przeczytaj rano.
            </p>
            <h4 class="subtitle4 mt-5 text-blue">Personalizacja</h4>
            <p class="text-gray-2 body3 mb-0">
              Pracujesz w kilku szkołach? Przypisz wybraną nazwę i kolor do
              placówki, by sprawnie porządkować dane.
            </p>
            <h4 class="subtitle4 mt-5 text-blue">Aktualizacja danych</h4>
            <p class="text-gray-2 body3 mb-0">
              Najważniejsze zawodowe informacje docierają do Ciebie na bieżąco.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section-academia-bg">
      <div class="container">
        <div class="row px-3">
          <div class="col-12 section-md-bg-content">
            <div class="text-center">
              <h3 class="heading3 text-white text-uppercase mt-0">
                AKADEMIA LIBRUS W APLIKACJI
              </h3>
              <p class="text-white body1">
                Korzystaj z zasobów platformy szkoleniowej na smartfonie.
                <br />
                Zadbaj o swój rozwój w dowolnym miejscu i czasie.
              </p>
            </div>
          </div>
          <div class="row mt-3 py-3">
            <div
              class="col-lg-3 col-md-6 col-sm-12 my-4 my-md-0 text-center d-flex flex-column align-items-center"
            >
              <div class="ac-icon">
                <img src="../assets/images/icons/ac-trace-news.svg" />
              </div>
              <p class="mt-4 mx-auto body2 text-white">
                Śledź wygodnie nowości i oglądaj
                <b>specjalistyczne szkolenia</b>
              </p>
            </div>
            <div
              class="col-lg-3 col-md-6 col-sm-12 my-4 my-md-0 text-center d-flex flex-column align-items-center"
            >
              <div class="ac-icon">
                <img src="../assets/images/icons/ac-webinars.svg" />
              </div>
              <p class="mt-4 mx-auto body2 text-white">
                Dołączaj z każdego miejsca do wyjątkowych
                <b>spotkań live</b> (na żywo) i <b>sesji Q&A</b>
              </p>
            </div>
            <div
              class="col-lg-3 col-md-6 col-sm-12 my-4 my-md-0 text-center d-flex flex-column align-items-center"
            >
              <div class="ac-icon">
                <img src="../assets/images/icons/ac-certificate.svg" />
              </div>
              <p class="mt-4 mx-auto body2 text-white">
                Generuj, pobieraj i przesyłaj na swój e-mail
                <b>zaświadczenia</b>
              </p>
            </div>
            <div
              class="col-lg-3 col-md-6 col-sm-12 my-4 my-md-0 text-center d-flex flex-column align-items-center"
            >
              <div class="ac-icon">
                <img src="../assets/images/icons/ac-materials.svg" />
              </div>
              <p class="mt-4 mx-auto body2 text-white">
                Przeglądaj i zapisuj niepowtarzalne
                <b>materiały szkoleniowe</b>, bez uruchamiania komputera
              </p>
            </div>
          </div>
          <div class="col-12 py-5 text-center">
            <a
              href="https://akademia.librus.pl/"
              rel="noopener noreferrer"
              target="_blank"
              class="btn btn-outline-light btn-min-width text-uppercase mx-3 mt-3 mt-lg-0"
            >
              O Akademii Librus
            </a>
          </div>
        </div>
      </div>
    </section>
    <section class="section-white">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="heading2 text-black text-uppercase text-center mb-0">
              ZACZNIJ KORZYSTAĆ Z APLIKACJI<br />LIBRUS NAUCZYCIEL
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-5 mt-5 text-center">
            <p class="heading4 text-black mt-1">Załóż Konto Librus</p>
            <a
              href="https://rodzina.librus.pl"
              class="btn btn-default btn-cta btn-cta--medium mt-0 text-uppercase"
              style="width: 184px"
              >Zakładam!</a
            >
          </div>
          <div class="col-md-2 mt-5 d-none d-lg-block">
            <span class="separator bg-white" />
          </div>
          <div class="col-lg-5 mt-5 pr-0 text-center">
            <p class="heading4 text-black mt-1">Pobierz bezpłatną aplikację</p>
            <a
              href="https://play.google.com/store/apps/details?id=pl.librus.teacher"
              rel="noopener noreferrer"
              target="_blank"
              class="mr-4"
            >
              <img
                src="../assets/images/icons/google_play.svg"
                class="gp-img-btn"
              />
            </a>
            <a
              href="https://apps.apple.com/pl/app/librus-nauczyciel/id1591474710"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src="../assets/images/icons/App_store_black.svg"
                class="as-img-btn"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
    <section class="section-grey">
      <div class="container">
        <div class="text-center mx-auto static-mw">
          <p class="caption2 mb-0 text-grey">
            Korzystanie z aplikacji Librus Nauczyciel wymaga założenia Konta
            LIBRUS.
          </p>
          <p class="caption2 mb-0 text-grey">
            Usługa Natychmiastowe Powiadomienia jest świadczona na wybranych
            platformach mobilnych.
          </p>
          <p class="caption2 mb-0 text-grey">
            Działanie poszczególnych funkcji aplikacji Librus Nauczyciel może
            być uzależnione od ich wykorzystania przez szkołę. Jeśli szkoła nie
            korzysta z danego modułu czy funkcji w systemie Synergia, nie będą
            one dostępne również w aplikacji Librus Nauczyciel, dopóki szkoła
            ich nie włączy.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "NauczycielView",
  created() {
    this.$emit("showFaqHeader", false);
  },
  mounted() {
    document.title = "Librus Nauczyciel";
  },
};
</script>
<style scoped>
.flex-bottom {
  align-items: flex-end;
}
.list-margin {
  margin-left: 20px;
}
</style>
